import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { logoutRequest } from '../store/actions/AuthActions';
import { isLoggedIn } from '../helperFunctions';

const PracticeAuthWrapper = ({ children }) => {
  const dispatch = useDispatch();
  const { user_id } = useSelector(state => state.auth);
  const companyId = localStorage.getItem('company_id');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if we have tokens to indicate auth process is in progress
    const hasTokens = localStorage.getItem('access-token') && localStorage.getItem('refresh-token');

    if (hasTokens) {
      // If we have tokens but user_id is still empty, wait for auth to complete
      if (!isLoggedIn(user_id)) {
        const timer = setTimeout(() => {
          setIsLoading(false);
        }, 1500); // Wait 1.5 seconds for auth to complete
        return () => clearTimeout(timer);
      }
    }

    setIsLoading(false);
  }, [user_id]);

  // If still loading, show nothing or a spinner (we'll show nothing for now)
  if (isLoading) {
    return null;
  }

  // Check if user is not logged in or has incorrect company id for practice tests
  if (!isLoggedIn(user_id) || companyId !== '9999') {
    dispatch(logoutRequest());
    return <Redirect to="/practices-test/login" />;
  }

  // Otherwise, render the child component
  return children;
};

export default PracticeAuthWrapper;
